import styled from 'styled-components';

export const PeopleDrawerRoleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PeopleDrawerRoleTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 10px;
`;

export const PeopleDrawerRoleTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const PeopleDrawerRoleTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const PeopleDrawerRoleDescription = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  white-space: pre-wrap;

  color: var(--color-text);
`;

export const PeopleDrawerRoleLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 60px;
`;
